import { render, staticRenderFns } from "./cl-tags-large.vue?vue&type=template&id=6553b96f&scoped=true&"
import script from "./cl-tags-large.vue?vue&type=script&lang=ts&"
export * from "./cl-tags-large.vue?vue&type=script&lang=ts&"
import style0 from "./cl-tags-large.vue?vue&type=style&index=0&id=6553b96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553b96f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
